export enum MailboxType {
  PrimaryUserMailbox = 0,
  SharedMailbox = 1,
  LinkedMailbox = 2,
}

export interface MailboxInformation {
  mailboxType: MailboxType;
  mailboxSmtpAddress: string;
  auxiliaryMailboxGuid?: string;
}
